export default "__VITE_ASSET__BWyS1qcS__"